import React, { Component } from 'react';
import { Label, Input, Button } from 'reactstrap';
import Select from 'react-select';
import If from '../../Shared/If';
import { isMobile } from '../../../utils/deviceInfo';
import {isTrivvyProduct, manageRoleText, roleOptions} from '../../../utils/constants';


export default class OfficeSetupMember extends Component {

    constructor(props) {
        super(props);
        this.state = {
            firstName: false,
            lastName:false,
            email:'',
            mobileNumber:'',
            fName:'',
            lName:''
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.memberData && !this.props.memberData) {
            this.setState({
                firstName: false,
                lastName: false,
                email: '',
                mobileNumber: '',
                fName: '',
                lName: ''
            });
        }
    }

    render() {
        let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g
        let props = this.props
        console.log(this.props)
        let {firstName, lastName, fName, lName, email, mobileNumber}=this.state

        const roleValue = manageRoleText(props.memberData)
   
        return (
        <div className="row" style={{marginTop:20}}>
            <div className="col">
                <Select name="role" 
                  options={roleOptions
                    //   this.props.user.role==='Member'? roleOptions.filter(e=> e.value=='Member'):roleOptions
                    } 
                  value={roleValue}
                  simpleValue
                  clearable={false}
                //   disabled={isTrivvyProduct}
                onChange={(value) => props.onInputChange(props.id,{name : 'role',value : value})}/>
            </div>
            <div className="col">
                <Input type="email" name="email"
                value={props.memberData ? email:''}
                    placeholder="e.g. jane@doe.com"
                    onChange={({target}) => {
                        this.setState({email: target.value})
                        props.onInputChange(props.id,target)
                    }}
                />
            </div>
            <div className="col">
                <Input type="tel" name="mobileNumber"
                value={props.memberData ? mobileNumber:''}
                    placeholder="e.g. +1234567890"
                    onFocus={() => {
                        if (!mobileNumber) {
                            this.setState({mobileNumber: '+1'});
                            props.onInputChange(props.id, {name: 'mobileNumber', value: '+1'});
                        }
                    }}
                    onChange={({target}) => {
                        this.setState({mobileNumber: target.value})
                        props.onInputChange(props.id,target)
                    }}
                />
            </div>
            <If condition={!isMobile}>
            <div className="col">
                <Input type="text" name="firstName" placeholder="e.g. Jane"
                    onChange={({target}) => {
                        if(specialChar.test(target.value)){
                            this.setState({firstName:true, fName: target.value})
                        }else{
                            this.setState({firstName:false, fName: target.value})
                            props.onInputChange(props.id,target)}
                        }
                    }
                    value={props.memberData ? fName:''}
                />
                {firstName===true && <div className="input-error-msg-field">Please remove any numbers or special characters.</div>}
            </div>
            <div className="col">
                <Input type="text" name="lastName" placeholder="e.g. Doe" 
                    onChange={({target}) => {
                        if(specialChar.test(target.value)){
                            console.log(target, target.name, target.value)
                            this.setState({lastName:true, lName: target.value})
                        }else{
                            this.setState({lastName:false, lName: target.value})
                            props.onInputChange(props.id,target)}
                        }
                    }
                    value={props.memberData ? lName:''}
                />
                {lastName===true && <div className="input-error-msg-field">Please remove any numbers or special characters.</div>}
            </div>
            </If>
        </div>
        )
    };
}

